var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ion-row',[_c('ion-col',{attrs:{"size":"12"}},[_c('div',{staticClass:"logo-wrapper"},[_c('img',{attrs:{"src":require("../../assets/svg/logo.svg")}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }